import { useContext } from 'react';
import DataContext from '../store/dataContext';
import { CROSS_MESSAGE, crossRequest } from '../commons/utils/cross-origin-communication';

export const useStoreApi = () => {
  const { storeVar, setStoreVar } = useContext(DataContext);

  const getLocalStorage = async valuesToSearch => {
    try {
      const apiResponse = await crossRequest(
        CROSS_MESSAGE.FETCH_LOCAL_STORAGE,
        {
          ...valuesToSearch,
          options: {
            method: 'GET',
            headers: {
              'x-api-internal': 'This API endpoint is for internal use only and may change in the future',
            },
          },
        },
        5000,
      );
      if (typeof apiResponse?.text === 'string') {
        setStoreVar(JSON.parse(apiResponse?.text));
      } else {
        setStoreVar(apiResponse?.text);
      }
    } catch (err) {
      // err
    }
  };

  return { getLocalStorage, storeVar };
};
